const getters = {
  dict: state => state.dict.dict,
}
export default getters
